import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

import { ITpsService } from './ITpsService';
import { TpsServiceExceptionDecorator } from './TpsServiceExceptionDecorator';
import { TpsServiceImpl } from './TpsServiceImpl';
import { TpsServiceLogDecorator } from './TpsServiceLogDecorator';

export class TpsServiceFactory {
  private static instance: TpsServiceFactory | null = null;
  private fddmStore: typeof useFloorplanDesignStore;

  public static initialize(fddmStore: typeof useFloorplanDesignStore) {
    TpsServiceFactory.instance = new TpsServiceFactory(fddmStore);
  }

  public static getInstance() {
    if (TpsServiceFactory.instance === null) {
      throw new Error(
        'TpsServiceFactory not yet initialized. Call TpsServiceFactory.initialize() first.',
      );
    }
    return TpsServiceFactory.instance;
  }

  private constructor(fddmStore: typeof useFloorplanDesignStore) {
    this.fddmStore = fddmStore;
  }

  public createTpsService(): ITpsService {
    let result: ITpsService = this.makeTpsService();

    result = new TpsServiceExceptionDecorator(result);
    result = new TpsServiceLogDecorator(result);

    return result;
  }

  private makeTpsService(): ITpsService {
    return new TpsServiceImpl(this.fddmStore);
  }
}
